import { render, staticRenderFns } from "./lookfile.vue?vue&type=template&id=1c128bcc&scoped=true&"
import script from "./lookfile.vue?vue&type=script&lang=js&"
export * from "./lookfile.vue?vue&type=script&lang=js&"
import style0 from "./lookfile.vue?vue&type=style&index=0&id=1c128bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c128bcc",
  null
  
)

export default component.exports